import { __spreadProps, __spreadValues } from "./armor-system-JQVN7XCJ.js";

// src/theme/legacy/makeCompatibility.ts
var makeCompatibility = function makeCompatibility(theme) {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j;
  var bodyColor = theme.body.color;
  if (!theme.typography.body.color) {
    theme.typography.body.color = bodyColor;
  }
  if (!theme.typography.pageTitle.color) {
    theme.typography.pageTitle.color = bodyColor;
  }
  if (!theme.typography.sectionTitle.color) {
    theme.typography.sectionTitle.color = bodyColor;
  }
  if (!theme.typography.subSectionTitle.color) {
    theme.typography.subSectionTitle.color = bodyColor;
  }
  if (!theme.typography.labelLarge.color) {
    theme.typography.labelLarge.color = bodyColor;
  }
  if (!theme.typography.labelMedium.color) {
    theme.typography.labelMedium.color = bodyColor;
  }
  if (!theme.typography.labelSmall.color) {
    theme.typography.labelSmall.color = bodyColor;
  }
  if (!theme.typography.paragraphLarge.color) {
    theme.typography.paragraphLarge.color = bodyColor;
  }
  if (!theme.typography.paragraphMedium.color) {
    theme.typography.paragraphMedium.color = bodyColor;
  }
  if (!theme.typography.paragraphSmall.color) {
    theme.typography.paragraphSmall.color = bodyColor;
  }
  var colors = theme.color;
  theme.color = __spreadProps(__spreadValues({}, theme.color), {
    primary: __spreadValues({
      dark: colors.primary["08"],
      // colorBlue70,
      main: colors.primary["07"],
      // colorBlue60,
      light: colors.primary["06"],
      // colorBlue50,
      lighter: colors.primary["03"],
      // colorBlue20,
      lightest: colors.primary["01"]
    }, (_b = (_a = theme.color) == null ? void 0 : _a.primary) != null ? _b : {}),
    accent: __spreadValues({
      darker: colors.accent["10"],
      // colorTurquoise90,
      dark: colors.accent["09"],
      // colorTurquoise80,
      main: colors.accent["08"],
      // colorTurquoise70,
      light: colors.accent["07"]
    }, (_d = (_c = theme.color) == null ? void 0 : _c.accent) != null ? _d : {}),
    success: __spreadValues({
      main: colors.success["07"],
      // colorGreen60,
      light: colors.success["02"]
    }, (_f = (_e = theme.color) == null ? void 0 : _e.success) != null ? _f : {}),
    warning: __spreadValues({
      main: colors.warning["07"],
      // colorYellow60,
      light: colors.warning["02"]
    }, (_h = (_g = theme.color) == null ? void 0 : _g.warning) != null ? _h : {}),
    error: __spreadValues({
      dark: colors.error["08"],
      // colorRed70,
      main: colors.error["07"],
      // colorRed60,
      light: colors.error["06"],
      // colorRed50,
      lighter: colors.error["02"]
    }, (_j = (_i = theme.color) == null ? void 0 : _i.error) != null ? _j : {})
  });
};
export { makeCompatibility };